// extracted by mini-css-extract-plugin
export default {"m":"20px","sirBorderRadiusM":"5px","label":"CheckBox_label__C-58k","checked":"CheckBox_checked__60fup"};